angular.module("vgresiduos").factory("additionalPropertyService", [
	"$http",
	"accountService",
	function ($http, accountService) {
		"use strict";

		const _listAdditionalProperties = function (dto) {
			const organizationId = accountService.getCurrentClient().organization.id;
			let parameters = "";
			if (dto) {
				parameters = $.param(dto);
			}

			const req = {
				method: "get",
				url:
					Vgr.constants.coreHostUrl +
					Vgr.resources.core.additionalProperties.replace("[ORGANIZATION_ID]", organizationId) +
					"?" +
					parameters
			};
			return $http(req);
		};

		const _getAdditionalProperty = function (id) {
			const organizationId = accountService.getCurrentClient().organization.id;

			const req = {
				method: "get",
				url:
					Vgr.constants.coreHostUrl +
					Vgr.resources.core.additionalProperties.replace("[ORGANIZATION_ID]", organizationId) +
					"/" +
					id
			};
			return $http(req);
		};

		const _listClientProperties = function (dto) {
			if (!dto) {
				dto = dto || {};
			}

			dto.organizationUnitId = accountService.getCurrentClient().id;

			return _listAdditionalProperties(dto);
		};

		return {
			getAdditionalProperty: _getAdditionalProperty,
			listClientProperties: _listClientProperties
		};
	}
]);
